import React, { useRef, useMemo, useState, useEffect } from 'react';
import { useMemoizedFn } from 'ahooks';
import { Select, SelectProps } from 'tea-component';
// @ts-ignore
import { isEmpty } from '@gp/utils/utils';

interface ISelectWithPlaceholderHoverProps extends SelectProps {
  invalidValues?: any[];
}

const SelectWithPlaceholderHover: React.FC<ISelectWithPlaceholderHoverProps> = (props) => {
  const {
    invalidValues,
    defaultValue: defaultValueProps,
    value: valueProps,
    onChange: onChangeProps,
    placeholder: placeholderProps,
    ...remains
  } = props;

  const comp = useRef<any>(null);

  const [value, setValue] = useState(valueProps || defaultValueProps);

  const placeholder = useMemo<string>(() => {
    if (!isEmpty(value) && !invalidValues?.includes(value)) return '';
    return placeholderProps || '';
  }, [invalidValues, value, placeholderProps]);

  const handleChange = useMemoizedFn((value: string, context) => {
    setValue(value);
    onChangeProps?.(value, context);
  });

  useEffect(() => {
    if (!comp.current) return;
    const placeholderNode = comp.current.querySelector('.tea-dropdown__header > .tea-dropdown__value > .tea-text-weak');
    if (placeholderNode) {
      placeholderNode.setAttribute('title', placeholder);
    }
  }, [placeholder]);

  return (
    <>
      <Select ref={comp} placeholder={placeholder} value={value} onChange={handleChange} {...remains} />
    </>
  );
};

export default React.memo(SelectWithPlaceholderHover);
